import React from "react";
import { LucideIcon } from "lucide-react";

type EmptyStateProps = {
  icon: LucideIcon;
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-4 px-4 w-full">
      <Icon size={48} className="text-gray-400 mb-4" />
      {title && <h2 className="text-lg text-gray-400">{title}</h2>}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-4 inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-400 border border-gray-400 rounded-md hover:bg-indigo-50 hover:text-slate-950 transition"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};
